/* eslint-disable react/jsx-filename-extension */
import 'core-js/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import WidgetApp from './components/WidgetApp/WidgetApp';

const domNode = document.getElementById('page-wrapper');
ReactDOM.render(<WidgetApp />, domNode);

// get param. if oai_widget, then hack the font
// temporary for openai chatgpt integration
const urlParams = new URLSearchParams(window.location.hash);

function setGlobalStylesForOpenAI() {
  const head = document.getElementsByTagName('head')[0];
  const styleId = 'oai-widget-style-overrides';
  if (document.getElementById(styleId)) {
    return;
  }
  const style = document.createElement('style');
  style.id = styleId;
  style.type = 'text/css';
  style.innerHTML = `
    * {
      font-family: ui-sans-serif, system-ui !important;
    }

    #page-wrapper .modal-dialog .modal-header,
    #page-wrapper .modal-dialog .modal-body {
      text-align: left;
    }

    #page-wrapper .modal-dialog .modal-header {
      padding: 0;
      margin-bottom: 12px;
    }

    #page-wrapper .modal-dialog .modal-body {
      padding: 0;
    }

    #page-wrapper .modal-dialog .modal-body p {
      padding: 0;
    }

    .WidgetPageHeader,
    .WidgetPageBody {
      padding-left: 5px;
    }
  `;
  head.appendChild(style);
}

if (urlParams.get('src') === 'oai_widget') {
  setGlobalStylesForOpenAI();
}
